module.exports = __webpack_public_path__ + "media/qipa.58510d3a.mp4";